// @ts-nocheck
import { AccordionStyle } from "@insite/mobius/Accordion/Accordion";
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import Minus, { MinusOffset } from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus, { PlusOffset } from "@store/Library/Components/Toolkit/Icons/Plus";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins/icon";
import { css } from "styled-components";

const borderWidth = "1px";
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        /* Store Custom Code - Start */
        background-color: ${getColor("common.background")};
        border: 1px solid ${getColor("common.borderDark")};
        border-left: none;
        border-bottom: none;
        border-right: none;
        color: ${getColor("text.main")};
        transition: ${transitionHoverStyles("background-color", "color", "border-color")};
        /* Store Custom Code - End */

        ${({ theme }) => css`
            ${breakpointValues(theme.design.accordion.padding.vertical, ["padding-top", "padding-bottom"])}
            ${breakpointValues(theme.design.accordion.padding.horizontal, ["padding-right", "padding-left"])}
            padding-left: 0; /* Store Custom Code */
            font-family: ${theme.design.typography.fontFamily.title /* Store Custom Code */};
            font-size: ${theme.design.typography.size.larger /* Store Custom Code */};
            font-weight: ${theme.design.typography.weight.base /* Store Custom Code */};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        /* Store Custom Code - Start */
        &[aria-expanded="true"] {
            background-color: ${getColor("common.background")};
            border-color: ${getColor("common.borderDark")}; /* Store Custom Code */
            border-bottom-color: transparent; /* Store Custom Code */
        }
        /* Store Custom Code - End */

        &:hover {
            color: ${getColor("primary.main")};
        }

        ${breakpoint("lg")} {
            font-size: ${x => x.theme.design.typography.size.large};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionProductDetailsSectionProps: AccordionSectionPresentationProps = {
    /* Store Custom Code - Start */
    css: css`
        border-bottom: 1px solid ${getColor("common.borderDark")};
    `,
    /* Store Custom Code - End */
    headerProps: {
        css: css`
            ${_headerButtonStyles()}

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: -${borderWidth};
            }

            ${AccordionStyle} + ${AccordionStyle} && {
                &:first-of-type button {
                    margin-top: -${borderWidth};
                }
            }

            /* Store Custom Code - Start */
            &[data-test-key="Videos"]:has(+ [aria-labelledby="videos"] .warning-no-documents) {
                display: none;
            }
            /* Store Custom Code - End */
        `,
    },
    panelProps: {
        css: css`
            ${({ theme }) => css`
                ${breakpointValues(theme.design.accordion.padding.horizontal, "padding")}
                ${
                    /* Store Custom Code - Start */
                    breakpointValues(theme.design.accordion.padding.vertical, [
                        "padding-top",
                        "padding-bottom",
                        "margin-bottom",
                    ])
                    /* Store Custom Code - End */
                }
            `}
            /* Store Custom Code - Start */
            background-color: ${getColor("common.accent")};
            border: none;

            &[aria-labelledby="videos"] {
                background-color: ${getColor("common.background")};

                &:has(.warning-no-documents) {
                    display: none;
                }
            }

            &[aria-labelledby="specifications"] {
                padding: 0;
                background-color: ${getColor("common.background")};
            }
            /* Store Custom Code - End */

            /* Store Removed - last-of-type */
        `,
    },
    expandIconProps: {
        src: Plus,
        color: "inherit",
        css: css`
            ${iconScalableStyles("1.2em", PlusOffset)}
            margin-left: 1em;
        `,
    },
    collapseIconProps: {
        src: Minus,
        color: "inherit",
        css: css`
            ${iconScalableStyles("1.2em", MinusOffset)}
            margin-left: 1em;
        `,
    },
};
